import { sleep, isWeiXin, isIos, getQueryString, isPhoneNumber } from '../../utils/index'<template>
    <div class="drive_div drive_div1">
        <div class="form_box">
            <div class="form-row">
                <div class="form-item">
                    <div class="label">姓名*</div>
                    <div class="iptbox">
                        <input class="ipt iptname" placeholder="请输入姓名" v-model="form.cnname" maxlength="30" />
                    </div>
                    <div class="error"></div>
                </div>
                <div class="form-item">
                    <div class="label">电话*</div>
                    <div class="iptbox">
                        <input class="ipt ipttel" placeholder="请输入电话号码" v-model="form.mobile" maxlength="11" />
                    </div>
                    <div class="error"></div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-item w100">
                    <div class="label">意向车型*</div>
                    <div class="iptbox sltbox">
                        <select class="ipt iptcar" v-model="form.cartype" @change="onCarTypeChange">
                            <option value="">选择车型</option>
                            <option v-for="(item, idx) in carType" :key="idx" :value="item.value">{{ item.text }}</option>
                             
                        </select>
                        <div class="arrow"></div>
                    </div>
                    <div class="error"></div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-row form-row2">
                    <div class="form-item">
                        <div class="label">省份*</div>
                        <div class="iptbox sltbox">
                            <select class="ipt iptprovince" v-model="form.province" @change="onProvinceChange">
                                <option value="">请选择省份</option> 
                                <option v-for="(item, idx) in province" :key="idx" :value="item.value">{{ item.text }}</option>
                            </select>
                            <div class="arrow"></div>
                        </div>
                        <div class="error"></div>
                    </div>
                    <div class="form-item">
                        <div class="label">城市*</div>
                        <div class="iptbox sltbox">
                            <select class="ipt iptcity" v-model="form.city" @change="onCityChange">
                                <option value="">请选择城市</option> 
                                <option v-for="(item, idx) in city" :key="idx" :value="item.value">{{ item.text }}</option>
                            </select>
                            <div class="arrow"></div>
                        </div>
                        <div class="error"></div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="label">经销商*</div>
                    <div class="iptbox sltbox">
                        <select class="ipt iptdealer" v-model="form.dealername" @change="onDealerChange">
                            <option value="">请选择经销商</option> 
                            <option v-for="(item, idx) in dealer" :key="idx" :value="item.value">{{ item.text }}</option>
                        </select>
                        <div class="arrow"></div>
                    </div>
                    <div class="error"></div>
                </div>
            </div>
            <div class="form-item">
                <div class="checkbox " :class="{ checked: guo }" @click="toggleGuo()">
                    <span @click.stop="toXieyi()">接受 《隐私条款》 </span>
                </div>
            </div>
            <div class="form-footer">
                <div class="btn btnsubmit" @click="submit()">预约试驾</div>
            </div>
        </div>
    </div>
</template>
<script>
import { sleep, isWeiXin, isIos, getQueryString, isPhoneNumber } from '../../utils/index'
function isTestMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
export default {
    components: {},
    props:['cartype'],
    data() {
        return {
            visibleYishi: false,
            topSize: 0,
            popCheXi: false,
            popXi: false,
            guo: false,
            carType: [
                { value: '165280', text: 'RS Q8 quattro 45周年纪念版' },
                { value: '165340', text: 'RS 6 Avant GT' }
            ],
            province: [],
            city: [],
            dealer: [],

            form: {
                epchannlkey: '033051b3edeb408a9b2bc0bfbb7bdbb9',
                channel: '',
                utm_source: '',
                campaign: '2025年Audi RS车型上市',
                carseries: '6640',
                carseries_text: 'RS',
                cartype: '',
                cartype_text: '',
                cnname: '',
                mobile: '',
                province: '',
                province_text: '',
                city: '',
                city_text: '',
                dealername: '',
                dealer_text: ''
            }
        }
    },
    created(){
        if(this.cartype){
            this.form.cartype = this.cartype;
            var find = this.carType.find((it)=>{
                return it.value == this.cartype;
            });
            if(find){
                this.form.cartype_text = find.text;
            }
        }
    },
    mounted() { 
        var utm = getQueryString('utm')
        if (utm == '2502201931') {
            this.form.epchannlkey = 'f1d545681fc2419b99b39bf888f84d42'
            this.form.utm_source = '2502201931'
        } else if (utm == '2502201932') {
            this.form.epchannlkey = '6c128beacaa249b7a7adad09aac2c99a'
            this.form.utm_source = '2502201932'
        } else if (utm == '2502201934') {
            this.form.epchannlkey = 'f12af030f45d4e8fbcafec6413ef1b63'
            this.form.utm_source = '2502201934'
        }
        var channel = getQueryString('channel')
        if (!channel) channel = 1
        this.form.channel = channel
        this.timelineList = []

        this.bindEvents()
        this.initProvince()
    },
    methods: {
        bindEvents() {
            $(window).scrollTop(0)
        },

        // 预约试驾---------------------------
        onCarTypeChange() {
            var it = this.carType.find((it) => {
                return it.value == this.form.cartype
            })
            if (it) {
                this.form.cartype_text = it.text
            } else {
                this.form.cartype_text = ''
            }
        },

         
        toggleGuo() {
            this.guo = !this.guo
        
        },
        toXieyi(){
            window.open('https://www.audi.cn/zh/privacy.html')
        },
        initProvince() {
            for (var k in dprovinces) {
                this.province.push({
                    text: dprovinces[k][1],
                    value: dprovinces[k][0]
                })
            }
        },

        initCity() {
            this.form.city = ''
            this.form.city_text = ''
            this.form.dealername = ''
            this.form.dealer_text = ''
            this.city = []
            this.dealer = []
            var citys = dcitys[this.form.province]
            for (var k in citys) {
                this.city.push({
                    text: citys[k][1],
                    value: citys[k][0]
                })
            }
        },

        initDealer() {
            this.form.dealername = ''
            this.form.dealer_text = ''
            this.dealer = []
            if (q8dealers[this.form.city]) {
                var ds = q8dealers[this.form.city]
                for (var k in ds) {
                    this.dealer.push({
                        text: ds[k][1],
                        value: ds[k][0]
                    })
                }
            }
        },

        onProvinceChange() {
            var it = this.province.find((it) => {
                return it.value == this.form.province
            })
            if (it) {
                this.form.province_text = it.text
            } else {
                this.form.province_text = ''
            }
            this.initCity()
            console.log(this.form)
        },
        onCityChange() {
            var it = this.city.find((it) => {
                return it.value == this.form.city
            })
            if (it) {
                this.form.city_text = it.text
            } else {
                this.form.city_text = ''
            }
            this.initDealer()
            console.log(this.form)
        },
        onDealerChange() {
            var it = this.dealer.find((it) => {
                return it.value == this.form.dealername
            })
            if (it) {
                this.form.dealer_text = it.text
            } else {
                this.form.dealer_text = ''
            }
        },
        submit() {
            if (this.submitflag) return 
            if (!this.form.cnname) {
                this.$alert('请填写您的姓名')
                return
            }
            if (!this.form.mobile) {
                this.$alert('请填写您的电话号码')
                return
            }
            if (!isPhoneNumber(this.form.mobile)) {
                this.$alert('电话号码格式错误')
                return
            }
            if (!this.form.cartype) {
                this.$alert('请选择车型')
                return
            }
            if (!this.form.province) {
                this.$alert('请选择省份')
                return
            }
            if (!this.form.city) {
                this.$alert('请选择城市')
                return
            }
            if (!this.form.dealername) {
                this.$alert('请选择经销商')
                return
            }
            if (!this.guo) {
                this.$alert('您还未同意隐私条款')
                return
            }
            this.submitData()
        },
        submitData() {
            this.submitflag = true
            var that = this
            var fm = new FormData()
            fm.append('epchannlkey', this.form.epchannlkey)
            fm.append('channel', this.form.channel)
            fm.append('utm_source', this.form.utm_source)
            fm.append('campaign', this.form.campaign)
            fm.append('carseries', this.form.carseries)
            fm.append('cartype', this.form.cartype)
            fm.append('cnname', this.form.cnname)
            fm.append('mobile', this.form.mobile)
            fm.append('province', this.form.province)
            fm.append('city', this.form.city)
            fm.append('dealername', this.form.dealername)

            window.startCaptcha(function (issuccess, captchaId) {
                if (!issuccess) {
                    that.submitflag = false
                    return
                }
                fm.append('captchaid', captchaId)
                that.saveStmClick(that.form)
                $.ajax({
                    type: 'POST',
                    url: 'https://contact.audi.cn/contact/student/testdrive/testdrive_addReleaseFtrueAppEP',
                    data: fm,
                    contentType: false,
                    processData: false,
                    success: function (res) {
                        if (res.success) {
                            that.$alert('提交成功', true)
                            that.clearForm()
                        } else {
                            that.$alert(res.message)
                        }
                    },
                    complete: function () {
                        that.submitflag = false
                    }
                })
            })
        },
        saveStmClick(data) {
            try {
                var name = data.cnname.substr(0, 1) + '**'
                var mobile = data.mobile.substr(0, 3) + '****' + data.mobile.substr(7, 4)
                stm_clicki('send', 'event', {
                    customActionId: 1,
                    customActionLabel1: data.cartype_text,
                    customActionLabel2: name,
                    customActionLabel3: mobile,
                    customActionLabel4: data.province_text,
                    customActionLabel5: data.city_text,
                    customActionLabel6: data.dealer_text,
                    customActionLabel7: 'RS页面',
                    customActionValue1: 1
                })
            } catch (e) {}
        },
        clearForm() {
            this.form.cartype = ''
            this.form.cartype_text = ''
            this.form.cnname = ''
            this.form.mobile = ''
            this.form.province = ''
            this.form.province_text = ''
            this.form.city = ''
            this.form.city_text = ''
            this.form.dealername = ''
            this.form.dealer_text = ''
            this.guo = false
        }
        // 预约试驾---------------------------
    },
    beforeDestroy() { 
        TweenMax.killTweensOf('*') 
        console.log('清除动画')
    }
}
</script>
<style scoped lang="scss">
.drive_div1 {
    width: 100%;
    height: 583px;
    position: absolute;
    z-index: 3;
    background-color: rgba(0, 0, 0, 0.85);
    left: 0;
    bottom: 0;
    .form_box {
        width: 838px;
        margin: 0 auto;
        padding-top: 40px;
        .form-row {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            &.form-row2 {
                width: 48%;
            }
        }

        .ipt {
            font-size: 18px;
            line-height: 35px;
            margin-top: 10px;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: keep-all;
            white-space: nowrap;
            option {
                background-color: rgba(0, 0, 0, 0.8);
                color: #fff;
                font-size: 18px;
            }
        }

        .form-item {
            width: 48%;
            position: relative;
            padding-top: 20px;
            &.w100 {
                width: 100%;
                .arrow {
                    // right: 400px;
                }
            }
            .label {
                font-size: 18px;
                line-height: 22px;
            }
            .iptbox {
                border-bottom: 1px solid #383838;
                position: relative;
                &.sltbox {
                    padding-right: 20px;
                }
            }
            .error {
                height: 25px;
                font-size: 12px;
                line-height: 22px;
                color: #d20630;
                padding-top: 5px;
            }
            .arrow {
                display: block;
                width: 12px;
                height: 12px;
                background: url(../../assets/index/page2_arrow.svg) no-repeat center center;
                background-size: contain;
                position: absolute;
                opacity: 0.5;
                z-index: 2;
                right: 5px;
                top: 24px;
            }
            .iptcar {
                font-size: 24px;
                font-family: 'audi_extended_bold_4.03';
            }
            .checkbox {
                height: 26px;
                background: url(../../assets/index/page2_echeck.svg) no-repeat left center;
                background-size: contain;
                font-size: 18px;
                line-height: 26px;
                padding-left: 34px;
                position: relative;
                cursor: pointer;
                &.checked {
                    &::before {
                        content: ' ';
                        height: 30px;
                        width: 30px;
                        background: url(../../assets/index/page2_echeck_on.svg) no-repeat left center;
                        background-size: contain;
                        position: absolute;
                        left: -2px;
                        top: -4px;
                        z-index: 2;
                    }
                }
            }
        }
        .form-footer {
            padding-top: 30px;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            .btn {
                width: 224px;
                height: 53px;
                cursor: pointer;
                font-size: 18px;
                line-height: 53px;
                text-align: center;
                background: url(../../assets/index/page2_btn1.png) no-repeat center center;
                background-size: contain;
                &:hover {
                    background: url(../../assets/index/page2_btn2.png) no-repeat center center;
                    background-size: contain;
                }
            }
        }
    }
}
</style>
